import texts from '@components/Products/FixedDeposits/en.json';
import { Text, Image } from '@ui/atoms';

const HowToPickRight = () => {
    return (
        <div className="relative py-8 xl:py-12 bg-primary-500">
            <div className="max-w-screen-maxScreen mx-auto px-4">
                <Text
                    content={texts.fdPickingTips.heading}
                    className="h4-semibold md:h3-semibold xl:h2-semibold text-center text-basicWhite"
                    htmlTag="h2"
                />
                <div className="flex justify-center">
                    <div className="mt-10 grid grid-cols-1 xl:grid-cols-2 gap-x-8 gap-y-10">
                        {texts.fdPickingTips.factors.map((factor, index) => (
                            <div
                                key={index}
                                className="flex xl:flex-col gap-4 xl:gap-2 max-w-[496px]"
                            >
                                <Image
                                    src={factor.image}
                                    alt={factor.title}
                                    className="w-10 h-10 xl:w-12 xl:h-12 mt-0.5"
                                />
                                <div className='flex flex-col gap-2'>
                                <Text
                                    content={factor.title}
                                    className="h5-semibold text-secondary-400"
                                />
                                <Text
                                    content={factor.description}
                                    className="p4-regular text-basicWhite"
                                />
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            <Image
                src={'/images/products/jiraaf-arrow.svg'}
                className="absolute right-0 top-0 hidden xl:block"
            />
        </div>
    );
};

export default HowToPickRight;
